import { StockTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { StockType } from '@/services/graphql/types';

export const mapperStockTypeDataEnum = createEnumMapperFunction(
  StockType,
  StockTypeDataEnum
);
